import React from 'react';

const ModalComponent = ({ title, message, show, handleClose, showWhats }) => {


    const renderWhatsButton = () => {

        const whatsappUrl = process.env.REACT_APP_WHATSAPP_URL;

        return (
            <div className='whats-button'>
            <a href={whatsappUrl || "#"} target="_blank" rel="noopener noreferrer">
                    <img style={{width:'13rem'}}
                    src={`${process.env.PUBLIC_URL}/assets/whatsapp.png`}
                    alt="WhatsApp"

                />
            </a>
            </div>
        )
    };


    return (
        <div className={`modal ${show ? 'd-block' : 'd-none'}`} tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                    </div>
                    <div className="modal-body">
                        <p>{message}</p>
                        {showWhats ? (<>{renderWhatsButton()}</>) : ("")}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" onClick={handleClose}>Ok</button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalComponent;
